import { apiResource } from "../../utils";
import parse from 'html-react-parser';

export function ArtistBio({ rows }) {
  return (
    <div style={{ maxWidth: "56rem", margin: "0 auto" }}>
      <div className="row g-4 align-items-center">
        <div className="col-12 col-md-6 d-flex justify-content-center">
          <img
            src={apiResource({
              url: rows.banner_small_event
            })}
            alt={rows.banner_small_event}
            style={{
              width: "100%",
              maxWidth: "28rem",
              borderRadius: "0.5rem",
              border: "1px solid rgba(237, 144, 13, 0.3)",
            }}
          />
        </div>

        <div className="col-12 col-md-6">
          <h2
            style={{
              fontSize: "2.25rem",
              fontWeight: 900,
              marginBottom: "1.5rem",
              background: "linear-gradient(to right, #fbbf24, #ef4444)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {rows.name_event}
          </h2>

          <div style={{ display: "flex", flexDirection: "column", gap: "1rem", color: "#d1d5db", lineHeight: 1.6 }}>
            {parse(`${rows.description_event}`)}
          </div>

          <div style={{ marginTop: "2rem", display: "flex", flexWrap: "wrap", gap: "0.75rem" }}>
            {[rows.name_type_event].map((genre) => (
              <span
                key={genre}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "rgba(180, 83, 9, 0.5)",
                  border: "1px solid rgba(237, 144, 13, 0.5)",
                  borderRadius: "9999px",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  color: "#fef3c7",
                }}
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
